"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Searchable = Searchable;
require("reflect-metadata");
const constants_1 = require("../constants");
function Searchable() {
    return (target, propertyKey) => {
        if (propertyKey) {
            const existing = Reflect.getMetadata(constants_1.MetaDatas.SEARCHABLE_MODEL, target) ?? [];
            if (!existing.includes(propertyKey)) {
                Reflect.defineMetadata(constants_1.MetaDatas.SEARCHABLE_MODEL, [...existing, propertyKey], target);
            }
        }
    };
}
